import axios from 'axios';
import { generateTimestampToken } from './timestampToken';

axios.interceptors.request.use(config => {
  // Append cache-busting timestamp to all GET requests
  if (config.method === 'get') {
    config.params = {
      ...config.params,
      _t: Date.now(),
    };
  }

  // Request token checked by the server on every API call
  config.headers['X-Request-Token'] = generateTimestampToken();

  return config;
});

export default axios;